import { Checkbox as CheckBoxMaterial } from '@mui/material';
import { FC, useEffect } from 'react';
import { Controller, Control, useFormContext } from 'react-hook-form';

import { Colors } from '@/assets';

interface IProps {
    onChange?: (value: boolean) => void;
    checked?: boolean;
    circle?: boolean;
    control?: Control;
    name: string;
}
export const Checkbox: FC<IProps> = ({ circle, name = 'test', onChange, checked }) => {
    const { register, setValue, watch } = useFormContext();

    useEffect(() => {
        register({ name });
    }, [register, name]);

    return (
        <CheckBoxMaterial
            name={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue(name, Boolean(e.target.checked), { shouldValidate: true, shouldDirty: true });
                onChange && onChange(e.target.checked);
            }}
            checked={watch(name) ?? checked}
            checkedIcon={
                <i
                    className={circle ? 'fas fa-check-circle' : 'fal fa-check-square'}
                    style={{ color: Colors.mediumPurpleViolet, fontSize: 20 }}
                />
            }
            icon={<i className={`fal fa-${circle ? 'circle' : 'square'}`} style={{ fontSize: 20 }} />}
            sx={{
                color: Colors.linkWater,
                p: 0.2
            }}
        />
    );
};
